import React from 'react';
import { connect } from "react-redux";
import {IState,AppActions, PaDocument, activityItem, PaDocumentV2} from '../../types/types'
import {ThunkDispatch} from 'redux-thunk'
import {SearchClick,GetListData, GetWfActivity, GetDocumentProfile,AddActComment, LoadPdf, SetSelectedRevision, GoBack, AddComment, StartInnmeldingsWorkflow, FavoritesClick, SetErrorMsgVisible, closeActivityWrapper} from '../../actions/folderViewActions'
import {KeyboardArrowUp} from '@mui/icons-material';
import { currPathValue, pdfMode, saveButtonMode, wfRetteType } from '../../types/enums';
import { MyActivitiesList } from '../DataTables/MyActivitiesList';
import { FrontPageToolbar } from './Toolbar';
import { ProarcDocument } from '../Document/Document';
import { DocumentList } from '../DataTables/DocumentList';
import { ProarcWfActivity } from '../Document/Activity';
import { fields, mapFieldToText } from "../../lang/constants";
import useScrollTrigger from '@mui/material/useScrollTrigger';
import CircularProgress from '@mui/material/CircularProgress';
import CssBaseline from '@mui/material/CssBaseline';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';
import Fab from '@mui/material/Fab';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';

interface FrontPageProps {
        isLoading: boolean;
        hasErrored: boolean;
        isVisible: boolean;

        dataIsLoading: boolean;

        documentDataIsLoading: boolean;
        activityDataIsLoading: boolean;
        
        recentDocs: PaDocumentV2[];
        favDocs: PaDocumentV2[];
        searchDocs: PaDocumentV2[];
        activities: activityItem[];

        currentPath: currPathValue;
        previousPath: currPathValue[];

        headerText:string;
        selectedDocument: PaDocument|null;
        selectedActivity: activityItem|null;
        // activityDecisions: activityDecisions|null;
        
        errorMsgVisible: boolean;
        errorMessage: any;

        hasRequiredGroups: boolean;

        doDocumentSearch: (value:string) => void;
        doGetWfActivity: (wfRno:number, actRno:number, title:string) => void;
        doGetDocumentProfile: (headerText:string, docRno:number, prevPath:currPathValue) => void;
        getListData: (value:currPathValue) => void;
        goBack: () => void;
        onLoadPdf: (fileRno:number, clientSide:boolean, mode: pdfMode, saveBtnMde: saveButtonMode) => void;
        onSetSelectedRevision: (docRno:number, revId:number) => void;
        onAddActComment: (wfRno:number,actRno:number,docRno:number,commLevel:number, commInput:string) => void;
        // onAddDocComment: (docRno:number, commLevel:number, commInput:string) => void;
        
        onAddComment: (docRno:number,commLevel:number,commInput:string,wfRno?:number,actRno?:number,file?:Blob, filename?: string, revRno?:number) => void;

        onStartInnmeldingsWorkflow:  (doc:PaDocument, revRno:number, wfDesc:string, wfNotes:string, wfType: wfRetteType) => void;
        onFavoriteClick: (docRno:number, isFavorite:boolean) => void;
        onSetErrorMsgVisible: (val:boolean)=> void;
        doCloseActivity: (wfRno:number, actRno:number, decision:string) => void;
      }

const FrontPage = (props:FrontPageProps) => {

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleToTopClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = (
      (event.target as HTMLDivElement).ownerDocument || document
    ).querySelector('#back-to-top-anchor');

    if (anchor) {
      anchor.scrollIntoView({
        block: 'center',
      });
    }
  };

  if (props.isVisible===false) {
    return <div className="not-visible"></div>;
  }

  if (props.hasErrored) {
      let body:any="";
      return <div className="error">
                  <p>Sorry! Error occured:</p>
                  {body}
              </div>;
  }

  if (props.isLoading) {
    return  <div className="material-table-outer-container">
              <CircularProgress />
            </div>;
    } 

  console.log("Render frontpage")
  return (
        <React.Fragment>
          <CssBaseline />
          <Table size="small" padding="none">
            <TableRow>
              <TableCell>
                <AppBar>
                  <FrontPageToolbar currentPath={props.currentPath} goBack={props.goBack} 
                      doDocumentSearch={props.doDocumentSearch} getListData={props.getListData}
                      header={props.headerText}
                      previousPath={props.previousPath}/>
                </AppBar>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Toolbar id="back-to-top-anchor" />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Container>
                  <Box sx={{ mt: 10 }}>
                    <Grid container spacing={0.5}>
                      { props.dataIsLoading && 
                        <Grid size={12} display="flex" justifyContent="center">
                          <CircularProgress />
                        </Grid>
                      }
                      {
                        props.currentPath === currPathValue.HomePage
                        &&
                        <Grid size={12}>
                             <Typography variant="h6">{mapFieldToText(fields.MAIN_TITLE)}</Typography>
                        </Grid>
                      }
                      {
                        props.currentPath === currPathValue.NoAccess
                        &&
                        <Grid size={12}>
                             <Typography variant="h6">{mapFieldToText(fields.NO_ACCESS)}</Typography>
                        </Grid>
                      }
                      {   (
                            props.currentPath === currPathValue.Recent 
                            ||
                            props.currentPath === currPathValue.Favorites
                            ||
                            props.currentPath === currPathValue.Search
                          )
                          && props.dataIsLoading === false &&
                          <DocumentList documents={
                                                    props.currentPath === currPathValue.Recent ? 
                                                      props.recentDocs: 
                                                        props.currentPath === currPathValue.Favorites ? 
                                                          props.favDocs
                                                            : props.searchDocs} 
                              currentPath={props.currentPath}
                              getDocumentData={props.doGetDocumentProfile} 
                              invokePath={props.currentPath}
                              favoriteClick={props.onFavoriteClick}
                              refresh={props.getListData}
                          />
                      }
                      {  props.currentPath === currPathValue.Activities
                          && props.dataIsLoading === false &&
                          <MyActivitiesList activities={props.activities} handleGetWfActivity={props.doGetWfActivity} refresh={props.getListData}/>
                      }
                      {  props.currentPath === currPathValue.Document
                          && props.dataIsLoading === false &&
                          <ProarcDocument doc={props.selectedDocument} 
                                          onLoadPdf={props.onLoadPdf} 
                                          onAddComment={props.onAddComment}
                                          onSetRevId={props.onSetSelectedRevision} 
                                          onStartInnmeldingsWf={props.onStartInnmeldingsWorkflow}
                                          docDataLoading={props.documentDataIsLoading}
                                          hasRequiredGroups={props.hasRequiredGroups}
                                          />
                      }
                      {  props.currentPath === currPathValue.WfActivity
                          && props.dataIsLoading === false &&
                          <ProarcWfActivity 
                            activity={props.selectedActivity} 
                            onLoadPdf={props.onLoadPdf} 
                            // onAddComment={props.onAddActComment}
                            onAddComment={props.onAddComment}
                            actDataLoading={props.activityDataIsLoading} 
                            onCloseActivity={props.doCloseActivity}
                            // activityDecisions={props.activityDecisions} 
                            />
                      }
                    </Grid>
                  </Box>
                </Container>
                <Fade in={trigger}>
                  <Box
                    onClick={handleToTopClick}
                    role="presentation"
                    sx={{ position: 'fixed', bottom: 16, right: 16 }}
                  >
                    <Fab size="small" aria-label="scroll back to top">
                      <KeyboardArrowUp />
                    </Fab>
                  </Box>
                </Fade>
              </TableCell>
            </TableRow>
            <Popover
                id="ErrorMessage"
                open={props.errorMsgVisible}
                anchorPosition={{ top: 100, left: 100 }}
                marginThreshold={20}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                onClose={()=>props.onSetErrorMsgVisible(false)}
                slotProps={{paper: {style: { width: '50%'}}}}
            >
                <Stack sx={{p:1}}>
                  <Typography><pre>{JSON.stringify(props.errorMessage, null, 2) }</pre></Typography>
                </Stack>
            </Popover>
          </Table>
        </React.Fragment>
  )
}

const mapStateToPropsContainer = (state:IState) =>{
  return {
      currentPath: state.uiItems.currentPath,
      previousPath: state.uiItems.previousPath,
      headerText: state.uiItems.headerText,

      selectedDocument: state.uiItems.selectedDocument,

      selectedActivity: state.uiItems.selectedActivity,      

      isLoading: state.uiState.MAIN_CONTAINER_IsLoading,
      hasErrored: state.uiState.MAIN_CONTAINER_HasErrored,
      isVisible: state.uiState.MAIN_CONTAINER_IsVisible,
      
      dataIsLoading: state.uiState.DATA_CONTAINER_IsLoading,
      documentDataIsLoading: state.uiState.DOC_DATA_CONTAINER_IsLoading,
      activityDataIsLoading: state.uiState.ACTIVITY_DATA_CONTAINER_IsLoading,

      recentDocs: state.uiItems.recentDocuments,
      favDocs: state.uiItems.favoriteDocuments,
      searchDocs: state.uiItems.documentSearchList,
      activities: state.uiItems.myActivities,

      errorMsgVisible: state.uiItems.errorMsgVisible,
      errorMessage: state.uiItems.errorMessage,

      hasRequiredGroups: state.uiItems.hasRequiredGroups
  }
};

export const mapDispatchToProps = (dispatch:ThunkDispatch<IState,undefined,AppActions>) => ({
  doDocumentSearch: (searchInput:string) => dispatch(SearchClick(searchInput)),
  getListData: (value:currPathValue) => dispatch(GetListData(value)),
  goBack: () => dispatch(GoBack()),
  doGetWfActivity: (wfRno:number, actRno:number, title:string) => dispatch(GetWfActivity(wfRno,actRno,title)),
  doGetDocumentProfile: (headerText:string, docRno:number, prevPath: currPathValue) => dispatch(GetDocumentProfile(headerText,docRno,prevPath)), 
  onLoadPdf: (fileRno:number, clientSide:boolean, mode: pdfMode, saveBtnMde: saveButtonMode) => dispatch(LoadPdf(fileRno,clientSide, mode, saveBtnMde)),
  onSetSelectedRevision: (docRno:number, revId:number) => dispatch(SetSelectedRevision(docRno, revId)),
  onAddActComment: (wfRno:number,actRno:number,docRno:number,commLevel:number, commInput:string) => dispatch(AddActComment(wfRno,actRno,docRno,commLevel, commInput)),
  onAddComment: (docRno:number,commLevel:number,commInput:string,wfRno?:number,actRno?:number,file?:Blob, filename?: string, revRno?:number) => dispatch(AddComment(docRno,commLevel,commInput,wfRno,actRno,file,filename,revRno)),
  onStartInnmeldingsWorkflow:  (doc:PaDocument, revRno:number, wfDesc:string, wfNotes:string, wfType: wfRetteType) => dispatch(StartInnmeldingsWorkflow(doc,revRno,wfDesc,wfNotes,wfType)),
  onFavoriteClick: (docRno:number, isFavorite:boolean) => dispatch(FavoritesClick(docRno,isFavorite)),
  onSetErrorMsgVisible: (val:boolean)=> dispatch(SetErrorMsgVisible(val)),
  //doCloseActivity: (wfRno:number, actRno:number, decision:string) => dispatch(closeActivity(wfRno,actRno,decision)),
  doCloseActivity: (wfRno:number, actRno:number, decision:string) => dispatch(closeActivityWrapper(wfRno,actRno,decision)),
  
})

export default connect(mapStateToPropsContainer,mapDispatchToProps)(FrontPage) 